module.exports = __webpack_public_path__ + "static/media/Effra-Light.f3e1735f.woff2";